export const STATUS_TONE_CLASSES = {
    neutral: 'bg-[var(--ak-identity-color-off-white)] text-[var(--ak-identity-color-gray)] ring-1 ring-[var(--ak-identity-color-beige)]',
    error: 'bg-[var(--ak-identity-color-red-50)] text-[var(--ak-identity-color-red-4)] ring-1 ring-[var(--ak-identity-color-red-200)]',
    success: 'bg-[var(--ak-identity-color-green-50)] text-[var(--ak-identity-color-green-4)] ring-1 ring-[var(--ak-identity-color-green-200)]',
    info: 'bg-[var(--ak-identity-color-blue-50)] text-[var(--ak-identity-color-blue-4)] ring-1 ring-[var(--ak-identity-color-blue-200)]',
};
export const STATUS_TEXT_CLASSES = {
    error: 'text-[var(--ak-identity-color-red-4)]',
    success: 'text-[var(--ak-identity-color-green-4)]',
};
